import logo from './logo.svg';
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Card from 'react-bootstrap/Card';
import Button from 'react-bootstrap/Button';
import CardDeck from 'react-bootstrap/CardDeck';

function App() {
  return (
    <div className="App">
    <section>
    <Container>
    <h1 style={{fontWeight: 'bold', paddingTop: 50, paddingBottom: 25}}>Wizard Free 3D Icons</h1>
    <h5 style={{paddingBottom: 25, color: '#333', textDecoration: 'none'}}>
    Designed & Developed by <a href="https://alluring-wizard.tech/" target="/blank" style={{color: 'blue', textDecoration: 'none'}}>
    Alluring Wizard</a></h5>
    </Container>
    </section>
    <Container>
      <CardDeck>
        <Card style={{backgroundColor: 'rgba( 255, 255, 255, 0.25 )',
                      boxShadow: '0 8px 32px 0 rgba( 31, 38, 135, 0.37 )',
                      backdropFilter: 'blur( 4px )',
                      webkitbackdropFilter: 'blur( 4px )',
                      borderRadius: '10px',
                      border: '1px solid #fff'}}>
          <Card.Body>
            <Card.Img variant="top" src="https://res.cloudinary.com/ddnflcfy1/image/upload/v1618551345/Wizard-3D-icons/camera-removebg-preview_ufgefh_yydjqh.png" style={{width: '50%'}} />
            <Button href="https://res.cloudinary.com/ddnflcfy1/image/upload/v1618551345/Wizard-3D-icons/camera-removebg-preview_ufgefh_yydjqh.png" download style={{marginTop: 30, width: '100%'}}>Download <i class="fa fa-download"></i></Button>
          </Card.Body>
        </Card>
        <Card style={{backgroundColor: 'rgba( 255, 255, 255, 0.25 )',
                      boxShadow: '0 8px 32px 0 rgba( 31, 38, 135, 0.37 )',
                      backdropFilter: 'blur( 4px )',
                      webkitbackdropFilter: 'blur( 4px )',
                      borderRadius: '10px',
                      border: '1px solid #fff'}}>
          <Card.Body>
          <Card.Img variant="top" src="https://res.cloudinary.com/ddnflcfy1/image/upload/v1618551344/Wizard-3D-icons/helix_loop_3-removebg-preview_swc4bc.png" style={{width: '50%'}} />
          <Button href="https://res.cloudinary.com/ddnflcfy1/image/upload/v1618551344/Wizard-3D-icons/helix_loop_3-removebg-preview_swc4bc.png" download style={{marginTop: 30, width: '100%'}}>Download <i class="fa fa-download"></i></Button>
          </Card.Body>
        </Card>
        <Card style={{backgroundColor: 'rgba( 255, 255, 255, 0.25 )',
                      boxShadow: '0 8px 32px 0 rgba( 31, 38, 135, 0.37 )',
                      backdropFilter: 'blur( 4px )',
                      webkitbackdropFilter: 'blur( 4px )',
                      borderRadius: '10px',
                      border: '1px solid #fff'}}>
          <Card.Body>
          <Card.Img variant="top" src="https://res.cloudinary.com/ddnflcfy1/image/upload/v1618551344/Wizard-3D-icons/cylinder-removebg-preview_rjn6qj.png" style={{width: '60%'}} />
          <Button href="https://res.cloudinary.com/ddnflcfy1/image/upload/v1618551344/Wizard-3D-icons/cylinder-removebg-preview_rjn6qj.png" download style={{marginTop: 30, width: '100%'}}>Download <i class="fa fa-download"></i></Button>
          </Card.Body>
        </Card>
        </CardDeck>

        <CardDeck style={{paddingTop: 30}}>
          <Card style={{backgroundColor: 'rgba( 255, 255, 255, 0.25 )',
                        boxShadow: '0 8px 32px 0 rgba( 31, 38, 135, 0.37 )',
                        backdropFilter: 'blur( 4px )',
                        webkitbackdropFilter: 'blur( 4px )',
                        borderRadius: '10px',
                        border: '1px solid #fff'}}>
            <Card.Body>
            <Card.Img variant="top" src="https://res.cloudinary.com/ddnflcfy1/image/upload/v1618551345/Wizard-3D-icons/bulls_eye-removebg-preview_wa4wkt_laqmbe.png" style={{width: '55%'}} />
            <Button href="https://res.cloudinary.com/ddnflcfy1/image/upload/v1618551345/Wizard-3D-icons/bulls_eye-removebg-preview_wa4wkt_laqmbe.png" download style={{marginTop: 30, width: '100%'}}>Download <i class="fa fa-download"></i></Button>
            </Card.Body>
          </Card>
          <Card style={{backgroundColor: 'rgba( 255, 255, 255, 0.25 )',
                        boxShadow: '0 8px 32px 0 rgba( 31, 38, 135, 0.37 )',
                        backdropFilter: 'blur( 4px )',
                        webkitbackdropFilter: 'blur( 4px )',
                        borderRadius: '10px',
                        border: '1px solid #fff'}}>
            <Card.Body>
            <Card.Img variant="top" src="https://res.cloudinary.com/ddnflcfy1/image/upload/v1618551345/Wizard-3D-icons/binocular-removebg-preview_ng7ujt_zees49.png" style={{width: '50%'}} />
            <Button href="https://res.cloudinary.com/ddnflcfy1/image/upload/v1618551345/Wizard-3D-icons/binocular-removebg-preview_ng7ujt_zees49.png" download style={{marginTop: 30, width: '100%'}}>Download <i class="fa fa-download"></i></Button>
            </Card.Body>
          </Card>
          <Card style={{backgroundColor: 'rgba( 255, 255, 255, 0.25 )',
                        boxShadow: '0 8px 32px 0 rgba( 31, 38, 135, 0.37 )',
                        backdropFilter: 'blur( 4px )',
                        webkitbackdropFilter: 'blur( 4px )',
                        borderRadius: '10px',
                        border: '1px solid #fff'}}>
            <Card.Body>
            <Card.Img variant="top" src="https://res.cloudinary.com/ddnflcfy1/image/upload/v1618551344/Wizard-3D-icons/dodecahedron-removebg-preview_m38f40.png" style={{width: '65%'}} />
            <Button href="https://res.cloudinary.com/ddnflcfy1/image/upload/v1618551344/Wizard-3D-icons/dodecahedron-removebg-preview_m38f40.png" download style={{marginTop: 30, width: '100%'}}>Download <i class="fa fa-download"></i></Button>
            </Card.Body>
          </Card>
          </CardDeck>

          <CardDeck style={{paddingTop: 30}}>
            <Card style={{backgroundColor: 'rgba( 255, 255, 255, 0.25 )',
                          boxShadow: '0 8px 32px 0 rgba( 31, 38, 135, 0.37 )',
                          backdropFilter: 'blur( 4px )',
                          webkitbackdropFilter: 'blur( 4px )',
                          borderRadius: '10px',
                          border: '1px solid #fff'}}>
              <Card.Body>
              <Card.Img variant="top" src="https://res.cloudinary.com/ddnflcfy1/image/upload/v1618551345/Wizard-3D-icons/cone-removebg-preview_did8j8.png" style={{width: '70%'}} />
              <Button href="https://res.cloudinary.com/ddnflcfy1/image/upload/v1618551345/Wizard-3D-icons/cone-removebg-preview_did8j8.png" download style={{marginTop: 30, width: '100%'}}>Download <i class="fa fa-download"></i></Button>
              </Card.Body>
            </Card>
            <Card style={{backgroundColor: 'rgba( 255, 255, 255, 0.25 )',
                          boxShadow: '0 8px 32px 0 rgba( 31, 38, 135, 0.37 )',
                          backdropFilter: 'blur( 4px )',
                          webkitbackdropFilter: 'blur( 4px )',
                          borderRadius: '10px',
                          border: '1px solid #fff'}}>
              <Card.Body>
              <Card.Img variant="top" src="https://res.cloudinary.com/ddnflcfy1/image/upload/v1618551344/Wizard-3D-icons/helix_loop-removebg-preview_r4imw8.png" style={{width: '50%'}} />
              <Button href="https://res.cloudinary.com/ddnflcfy1/image/upload/v1618551344/Wizard-3D-icons/helix_loop-removebg-preview_r4imw8.png" download style={{marginTop: 25, width: '100%'}}>Download <i class="fa fa-download"></i></Button>
              </Card.Body>
            </Card>
            <Card style={{backgroundColor: 'rgba( 255, 255, 255, 0.25 )',
                          boxShadow: '0 8px 32px 0 rgba( 31, 38, 135, 0.37 )',
                          backdropFilter: 'blur( 4px )',
                          webkitbackdropFilter: 'blur( 4px )',
                          borderRadius: '10px',
                          border: '1px solid #fff'}}>
              <Card.Body>
              <Card.Img variant="top" src="https://res.cloudinary.com/ddnflcfy1/image/upload/v1618551344/Wizard-3D-icons/helix_loop_2-removebg-preview_gvpvyb.png" style={{width: '55%'}} />
              <Button href="https://res.cloudinary.com/ddnflcfy1/image/upload/v1618551344/Wizard-3D-icons/helix_loop_2-removebg-preview_gvpvyb.png" download style={{marginTop: 30, width: '100%'}}>Download <i class="fa fa-download"></i></Button>
              </Card.Body>
            </Card>
            </CardDeck>

            <CardDeck style={{paddingTop: 30}}>
            <Card style={{backgroundColor: 'rgba( 255, 255, 255, 0.25 )',
                          boxShadow: '0 8px 32px 0 rgba( 31, 38, 135, 0.37 )',
                          backdropFilter: 'blur( 4px )',
                          webkitbackdropFilter: 'blur( 4px )',
                          borderRadius: '10px',
                          border: '1px solid #fff'}}>
              <Card.Body>
              <Card.Img variant="top" src="https://res.cloudinary.com/ddnflcfy1/image/upload/v1618551344/Wizard-3D-icons/cube-removebg-preview_rly0dn.png" style={{width: '50%'}} />
              <Button href="https://res.cloudinary.com/ddnflcfy1/image/upload/v1618551344/Wizard-3D-icons/cube-removebg-preview_rly0dn.png" download style={{marginTop: 30, width: '100%'}}>Download <i class="fa fa-download"></i></Button>
              </Card.Body>
            </Card>
            <Card style={{backgroundColor: 'rgba( 255, 255, 255, 0.25 )',
                          boxShadow: '0 8px 32px 0 rgba( 31, 38, 135, 0.37 )',
                          backdropFilter: 'blur( 4px )',
                          webkitbackdropFilter: 'blur( 4px )',
                          borderRadius: '10px',
                          border: '1px solid #fff'}}>
              <Card.Body>
              <Card.Img variant="top" src="https://res.cloudinary.com/ddnflcfy1/image/upload/v1618551344/Wizard-3D-icons/icosahedron-removebg-preview_z7d7lv.png" style={{width: '52%'}} />
              <Button href="https://res.cloudinary.com/ddnflcfy1/image/upload/v1618551344/Wizard-3D-icons/icosahedron-removebg-preview_z7d7lv.png" download style={{marginTop: 30, width: '100%'}}>Download <i class="fa fa-download"></i></Button>
              </Card.Body>
            </Card>
            <Card style={{backgroundColor: 'rgba( 255, 255, 255, 0.25 )',
                          boxShadow: '0 8px 32px 0 rgba( 31, 38, 135, 0.37 )',
                          backdropFilter: 'blur( 4px )',
                          webkitbackdropFilter: 'blur( 4px )',
                          borderRadius: '10px',
                          border: '1px solid #fff'}}>
              <Card.Body>
              <Card.Img variant="top" src="https://res.cloudinary.com/ddnflcfy1/image/upload/v1618551344/Wizard-3D-icons/pyramid-removebg-preview_b6unbh.png" style={{width: '57%'}} />
              <Button href="https://res.cloudinary.com/ddnflcfy1/image/upload/v1618551344/Wizard-3D-icons/pyramid-removebg-preview_b6unbh.png" download style={{marginTop: 30, width: '100%'}}>Download <i class="fa fa-download"></i></Button>
              </Card.Body>
            </Card>
              </CardDeck>

              <CardDeck style={{paddingTop: 30}}>
              <Card style={{backgroundColor: 'rgba( 255, 255, 255, 0.25 )',
                            boxShadow: '0 8px 32px 0 rgba( 31, 38, 135, 0.37 )',
                            backdropFilter: 'blur( 4px )',
                            webkitbackdropFilter: 'blur( 4px )',
                            borderRadius: '10px',
                            border: '1px solid #fff'}}>
                <Card.Body>
                <Card.Img variant="top" src="https://res.cloudinary.com/ddnflcfy1/image/upload/v1618551343/Wizard-3D-icons/torus_knot-removebg-preview_zvmahg.png" style={{width: '69%'}} />
                <Button href="https://res.cloudinary.com/ddnflcfy1/image/upload/v1618551343/Wizard-3D-icons/torus_knot-removebg-preview_zvmahg.png" download style={{marginTop: 30, width: '100%'}}>Download <i class="fa fa-download"></i></Button>
                </Card.Body>
              </Card>
              <Card style={{backgroundColor: 'rgba( 255, 255, 255, 0.25 )',
                            boxShadow: '0 8px 32px 0 rgba( 31, 38, 135, 0.37 )',
                            backdropFilter: 'blur( 4px )',
                            webkitbackdropFilter: 'blur( 4px )',
                            borderRadius: '10px',
                            border: '1px solid #fff'}}>
                <Card.Body>
                <Card.Img variant="top" src="https://res.cloudinary.com/ddnflcfy1/image/upload/v1618551343/Wizard-3D-icons/rubix_cube-removebg-preview_czsbaz_z7wrtu.png" style={{width: '50%'}} />
                <Button href="https://res.cloudinary.com/ddnflcfy1/image/upload/v1618551343/Wizard-3D-icons/rubix_cube-removebg-preview_czsbaz_z7wrtu.png" download style={{marginTop: 30, width: '100%'}}>Download <i class="fa fa-download"></i></Button>
                </Card.Body>
              </Card>
              <Card style={{backgroundColor: 'rgba( 255, 255, 255, 0.25 )',
                            boxShadow: '0 8px 32px 0 rgba( 31, 38, 135, 0.37 )',
                            backdropFilter: 'blur( 4px )',
                            webkitbackdropFilter: 'blur( 4px )',
                            borderRadius: '10px',
                            border: '1px solid #fff'}}>
                <Card.Body>
                <Card.Img variant="top" src="https://res.cloudinary.com/ddnflcfy1/image/upload/v1618551343/Wizard-3D-icons/star-removebg-preview_dckuja.png" style={{width: '51%'}} />
                <Button href="https://res.cloudinary.com/ddnflcfy1/image/upload/v1618551343/Wizard-3D-icons/star-removebg-preview_dckuja.png" download style={{marginTop: 30, width: '100%'}}>Download <i class="fa fa-download"></i></Button>
                </Card.Body>
              </Card>
                </CardDeck>

                <CardDeck style={{paddingTop: 30}}>
                <Card style={{backgroundColor: 'rgba( 255, 255, 255, 0.25 )',
                              boxShadow: '0 8px 32px 0 rgba( 31, 38, 135, 0.37 )',
                              backdropFilter: 'blur( 4px )',
                              webkitbackdropFilter: 'blur( 4px )',
                              borderRadius: '10px',
                              border: '1px solid #fff'}}>
                  <Card.Body>
                  <Card.Img variant="top" src="https://res.cloudinary.com/ddnflcfy1/image/upload/v1618551343/Wizard-3D-icons/torus_knot_2-removebg-preview_qgsm19.png" style={{width: '50%'}} />
                  <Button href="https://res.cloudinary.com/ddnflcfy1/image/upload/v1618551343/Wizard-3D-icons/torus_knot_2-removebg-preview_qgsm19.png" download style={{marginTop: 30, width: '100%'}}>Download <i class="fa fa-download"></i></Button>
                  </Card.Body>
                </Card>
                <Card style={{backgroundColor: 'rgba( 255, 255, 255, 0.25 )',
                              boxShadow: '0 8px 32px 0 rgba( 31, 38, 135, 0.37 )',
                              backdropFilter: 'blur( 4px )',
                              webkitbackdropFilter: 'blur( 4px )',
                              borderRadius: '10px',
                              border: '1px solid #fff'}}>
                  <Card.Body>
                  <Card.Img variant="top" src="https://res.cloudinary.com/ddnflcfy1/image/upload/v1618551343/Wizard-3D-icons/youtube-removebg-preview_cgkqso_ebcnqc.png" style={{width: '60%'}} />
                  <Button href="https://res.cloudinary.com/ddnflcfy1/image/upload/v1618551343/Wizard-3D-icons/youtube-removebg-preview_cgkqso_ebcnqc.png" download style={{marginTop: 30, width: '100%'}}>Download <i class="fa fa-download"></i></Button>
                  </Card.Body>
                </Card>
                <Card style={{backgroundColor: 'rgba( 255, 255, 255, 0.25 )',
                              boxShadow: '0 8px 32px 0 rgba( 31, 38, 135, 0.37 )',
                              backdropFilter: 'blur( 4px )',
                              webkitbackdropFilter: 'blur( 4px )',
                              borderRadius: '10px',
                              border: '1px solid #fff'}}>
                  <Card.Body>
                  <Card.Img variant="top" src="https://res.cloudinary.com/ddnflcfy1/image/upload/v1618551343/Wizard-3D-icons/teapot-removebg-preview_ysv2ed.png" style={{width: '50%'}} />
                  <Button href="https://res.cloudinary.com/ddnflcfy1/image/upload/v1618551343/Wizard-3D-icons/teapot-removebg-preview_ysv2ed.png" download style={{marginTop: 20, width: '100%'}}>Download <i class="fa fa-download"></i></Button>
                  </Card.Body>
                </Card>
                  </CardDeck>

                  <CardDeck style={{paddingTop: 30}}>
                  <Card style={{backgroundColor: 'rgba( 255, 255, 255, 0.25 )',
                                boxShadow: '0 8px 32px 0 rgba( 31, 38, 135, 0.37 )',
                                backdropFilter: 'blur( 4px )',
                                webkitbackdropFilter: 'blur( 4px )',
                                borderRadius: '10px',
                                border: '1px solid #fff'}}>
                    <Card.Body>
                    <Card.Img variant="top" src="https://res.cloudinary.com/ddnflcfy1/image/upload/v1618551343/Wizard-3D-icons/youtube_play_button-removebg-preview_akx3eg_rwkumj.png" style={{width: '57%'}} />
                    <Button href="https://res.cloudinary.com/ddnflcfy1/image/upload/v1618551343/Wizard-3D-icons/youtube_play_button-removebg-preview_akx3eg_rwkumj.png" download style={{marginTop: 30, width: '100%'}}>Download <i class="fa fa-download"></i></Button>
                    </Card.Body>
                  </Card>
                  <Card style={{backgroundColor: 'rgba( 255, 255, 255, 0.25 )',
                                boxShadow: '0 8px 32px 0 rgba( 31, 38, 135, 0.37 )',
                                backdropFilter: 'blur( 4px )',
                                webkitbackdropFilter: 'blur( 4px )',
                                borderRadius: '10px',
                                border: '1px solid #fff'}}>
                    <Card.Body>
                    <Card.Img variant="top" src="https://res.cloudinary.com/ddnflcfy1/image/upload/v1618551343/Wizard-3D-icons/videocam-removebg-preview_u77udh_x3is1v.png" style={{width: '80%'}} />
                    <Button href="https://res.cloudinary.com/ddnflcfy1/image/upload/v1618551343/Wizard-3D-icons/videocam-removebg-preview_u77udh_x3is1v.png" download style={{marginTop: 30, width: '100%'}}>Download <i class="fa fa-download"></i></Button>
                    </Card.Body>
                  </Card>
                  <Card style={{backgroundColor: 'rgba( 255, 255, 255, 0.25 )',
                                boxShadow: '0 8px 32px 0 rgba( 31, 38, 135, 0.37 )',
                                backdropFilter: 'blur( 4px )',
                                webkitbackdropFilter: 'blur( 4px )',
                                borderRadius: '10px',
                                border: '1px solid #fff'}}>
                    <Card.Body>
                    <Card.Img variant="top" src="https://res.cloudinary.com/ddnflcfy1/image/upload/v1618551343/Wizard-3D-icons/X-mas_tree-removebg-preview_n5ltlw_vrnl8a.png" style={{width: '35%'}} />
                    <Button href="https://res.cloudinary.com/ddnflcfy1/image/upload/v1618551343/Wizard-3D-icons/X-mas_tree-removebg-preview_n5ltlw_vrnl8a.png" download style={{marginTop: 30, width: '100%'}}>Download <i class="fa fa-download"></i></Button>
                    </Card.Body>
                  </Card>
                    </CardDeck>

                    <CardDeck style={{paddingTop: 30}}>
                    <Card style={{backgroundColor: 'rgba( 255, 255, 255, 0.25 )',
                                  boxShadow: '0 8px 32px 0 rgba( 31, 38, 135, 0.37 )',
                                  backdropFilter: 'blur( 4px )',
                                  webkitbackdropFilter: 'blur( 4px )',
                                  borderRadius: '10px',
                                  border: '1px solid #fff'}}>
                      <Card.Body>
                      <Card.Img variant="top" src="https://res.cloudinary.com/ddnflcfy1/image/upload/v1618551343/Wizard-3D-icons/whatsapp-removebg-preview_md3bz3_l7csxt.png" style={{width: '60%'}} />
                      <Button href="https://res.cloudinary.com/ddnflcfy1/image/upload/v1618551343/Wizard-3D-icons/whatsapp-removebg-preview_md3bz3_l7csxt.png" download style={{marginTop: 30, width: '100%'}}>Download <i class="fa fa-download"></i></Button>
                      </Card.Body>
                    </Card>
                    <Card style={{backgroundColor: 'rgba( 255, 255, 255, 0.25 )',
                                  boxShadow: '0 8px 32px 0 rgba( 31, 38, 135, 0.37 )',
                                  backdropFilter: 'blur( 4px )',
                                  webkitbackdropFilter: 'blur( 4px )',
                                  borderRadius: '10px',
                                  border: '1px solid #fff'}}>
                      <Card.Body>
                      <Card.Img variant="top" src="https://res.cloudinary.com/ddnflcfy1/image/upload/v1618551343/Wizard-3D-icons/specs-removebg-preview_1_xk7oku_c0hkga.png" style={{width: '93%'}} />
                      <Button href="https://res.cloudinary.com/ddnflcfy1/image/upload/v1618551343/Wizard-3D-icons/specs-removebg-preview_1_xk7oku_c0hkga.png" download style={{marginTop: 30, width: '100%'}}>Download <i class="fa fa-download"></i></Button>
                      </Card.Body>
                    </Card>
                    <Card style={{backgroundColor: 'rgba( 255, 255, 255, 0.25 )',
                                  boxShadow: '0 8px 32px 0 rgba( 31, 38, 135, 0.37 )',
                                  backdropFilter: 'blur( 4px )',
                                  webkitbackdropFilter: 'blur( 4px )',
                                  borderRadius: '10px',
                                  border: '1px solid #fff'}}>
                      <Card.Body>
                      <Card.Img variant="top" src="https://res.cloudinary.com/ddnflcfy1/image/upload/v1618551342/Wizard-3D-icons/rocket-2-removebg-preview_grk2qd_xgrs2d.png" style={{width: '50%'}} />
                      <Button href="https://res.cloudinary.com/ddnflcfy1/image/upload/v1618551342/Wizard-3D-icons/rocket-2-removebg-preview_grk2qd_xgrs2d.png" download style={{marginTop: 30, width: '100%'}}>Download <i class="fa fa-download"></i></Button>
                      </Card.Body>
                    </Card>
                      </CardDeck>

                      <CardDeck style={{paddingTop: 30}}>
                      <Card style={{backgroundColor: 'rgba( 255, 255, 255, 0.25 )',
                                    boxShadow: '0 8px 32px 0 rgba( 31, 38, 135, 0.37 )',
                                    backdropFilter: 'blur( 4px )',
                                    webkitbackdropFilter: 'blur( 4px )',
                                    borderRadius: '10px',
                                    border: '1px solid #fff'}}>
                        <Card.Body>
                        <Card.Img variant="top" src="https://res.cloudinary.com/ddnflcfy1/image/upload/v1618551342/Wizard-3D-icons/saturn-removebg-preview_gvm9es_eycear.png" style={{width: '80%'}} />
                        <Button href="https://res.cloudinary.com/ddnflcfy1/image/upload/v1618551342/Wizard-3D-icons/saturn-removebg-preview_gvm9es_eycear.png" download style={{marginTop: 75, width: '100%'}}>Download <i class="fa fa-download"></i></Button>
                        </Card.Body>
                      </Card>
                      <Card style={{backgroundColor: 'rgba( 255, 255, 255, 0.25 )',
                                    boxShadow: '0 8px 32px 0 rgba( 31, 38, 135, 0.37 )',
                                    backdropFilter: 'blur( 4px )',
                                    webkitbackdropFilter: 'blur( 4px )',
                                    borderRadius: '10px',
                                    border: '1px solid #fff'}}>
                        <Card.Body>
                        <Card.Img variant="top" src="https://res.cloudinary.com/ddnflcfy1/image/upload/v1618551342/Wizard-3D-icons/rocket-1-removebg-preview_gqb1y5_cw6twl.png" style={{width: '40%'}} />
                        <Button href="https://res.cloudinary.com/ddnflcfy1/image/upload/v1618551342/Wizard-3D-icons/rocket-1-removebg-preview_gqb1y5_cw6twl.png" download style={{marginTop: 30, width: '100%'}}>Download <i class="fa fa-download"></i></Button>
                        </Card.Body>
                      </Card>
                      <Card style={{backgroundColor: 'rgba( 255, 255, 255, 0.25 )',
                                    boxShadow: '0 8px 32px 0 rgba( 31, 38, 135, 0.37 )',
                                    backdropFilter: 'blur( 4px )',
                                    webkitbackdropFilter: 'blur( 4px )',
                                    borderRadius: '10px',
                                    border: '1px solid #fff'}}>
                        <Card.Body>
                        <Card.Img variant="top" src="https://res.cloudinary.com/ddnflcfy1/image/upload/v1618551342/Wizard-3D-icons/headphones-removebg-preview_guipxd_qtdkuu.png" style={{width: '62%'}} />
                        <Button href="https://res.cloudinary.com/ddnflcfy1/image/upload/v1618551342/Wizard-3D-icons/headphones-removebg-preview_guipxd_qtdkuu.png" download style={{marginTop: 30, width: '100%'}}>Download <i class="fa fa-download"></i></Button>
                        </Card.Body>
                      </Card>
                        </CardDeck>

                        <CardDeck style={{paddingTop: 30}}>
                        <Card style={{backgroundColor: 'rgba( 255, 255, 255, 0.25 )',
                                      boxShadow: '0 8px 32px 0 rgba( 31, 38, 135, 0.37 )',
                                      backdropFilter: 'blur( 4px )',
                                      webkitbackdropFilter: 'blur( 4px )',
                                      borderRadius: '10px',
                                      border: '1px solid #fff'}}>
                          <Card.Body>
                          <Card.Img variant="top" src="https://res.cloudinary.com/ddnflcfy1/image/upload/v1618551342/Wizard-3D-icons/microsoft_widows_logo-removebg-preview_tskkpx_gcb4yk.png" style={{width: '55%'}} />
                          <Button href="https://res.cloudinary.com/ddnflcfy1/image/upload/v1618551342/Wizard-3D-icons/microsoft_widows_logo-removebg-preview_tskkpx_gcb4yk.png" download style={{marginTop: 30, width: '100%'}}>Download <i class="fa fa-download"></i></Button>
                          </Card.Body>
                        </Card>
                        <Card style={{backgroundColor: 'rgba( 255, 255, 255, 0.25 )',
                                      boxShadow: '0 8px 32px 0 rgba( 31, 38, 135, 0.37 )',
                                      backdropFilter: 'blur( 4px )',
                                      webkitbackdropFilter: 'blur( 4px )',
                                      borderRadius: '10px',
                                      border: '1px solid #fff'}}>
                          <Card.Body>
                          <Card.Img variant="top" src="https://res.cloudinary.com/ddnflcfy1/image/upload/v1618551341/Wizard-3D-icons/glass-removebg-preview_1_mdjshl_vop0zq.png" style={{width: '50%'}} />
                          <Button href="https://res.cloudinary.com/ddnflcfy1/image/upload/v1618551341/Wizard-3D-icons/glass-removebg-preview_1_mdjshl_vop0zq.png" download style={{marginTop: 30, width: '100%'}}>Download <i class="fa fa-download"></i></Button>
                          </Card.Body>
                        </Card>
                        <Card style={{backgroundColor: 'rgba( 255, 255, 255, 0.25 )',
                                      boxShadow: '0 8px 32px 0 rgba( 31, 38, 135, 0.37 )',
                                      backdropFilter: 'blur( 4px )',
                                      webkitbackdropFilter: 'blur( 4px )',
                                      borderRadius: '10px',
                                      border: '1px solid #fff'}}>
                          <Card.Body>
                          <Card.Img variant="top" src="https://res.cloudinary.com/ddnflcfy1/image/upload/v1618551341/Wizard-3D-icons/gramaphone_record-removebg-preview_vpwznz_iozrsu.png" style={{width: '70%'}} />
                          <Button href="https://res.cloudinary.com/ddnflcfy1/image/upload/v1618551341/Wizard-3D-icons/gramaphone_record-removebg-preview_vpwznz_iozrsu.png" download style={{marginTop: 32, width: '100%'}}>Download <i class="fa fa-download"></i></Button>
                          </Card.Body>
                        </Card>
                          </CardDeck>

                          <CardDeck style={{paddingTop: 30, paddingBottom: 30}}>
                          <Card style={{backgroundColor: 'rgba( 255, 255, 255, 0.25 )',
                                        boxShadow: '0 8px 32px 0 rgba( 31, 38, 135, 0.37 )',
                                        backdropFilter: 'blur( 4px )',
                                        webkitbackdropFilter: 'blur( 4px )',
                                        borderRadius: '10px',
                                        border: '1px solid #fff'}}>
                            <Card.Body>
                            <Card.Img variant="top" src="https://res.cloudinary.com/ddnflcfy1/image/upload/v1618551342/Wizard-3D-icons/hat-removebg-preview_s9srlt_xeoxfv.png" style={{width: '50%'}} />
                            <Button href="https://res.cloudinary.com/ddnflcfy1/image/upload/v1618551342/Wizard-3D-icons/hat-removebg-preview_s9srlt_xeoxfv.png" download style={{marginTop: 30, width: '100%'}}>Download <i class="fa fa-download"></i></Button>
                            </Card.Body>
                          </Card>
                          <Card style={{backgroundColor: 'rgba( 255, 255, 255, 0.25 )',
                                        boxShadow: '0 8px 32px 0 rgba( 31, 38, 135, 0.37 )',
                                        backdropFilter: 'blur( 4px )',
                                        webkitbackdropFilter: 'blur( 4px )',
                                        borderRadius: '10px',
                                        border: '1px solid #fff'}}>
                            <Card.Body>
                            <Card.Img variant="top" src="https://res.cloudinary.com/ddnflcfy1/image/upload/v1618551345/Wizard-3D-icons/axis-removebg-preview_yqupdz_due6kd.png" style={{width: '48%'}} />
                            <Button href="https://res.cloudinary.com/ddnflcfy1/image/upload/v1618551345/Wizard-3D-icons/axis-removebg-preview_yqupdz_due6kd.png" download style={{marginTop: 30, width: '100%'}}>Download <i class="fa fa-download"></i></Button>
                            </Card.Body>
                          </Card>
                          <Card style={{backgroundColor: 'rgba( 255, 255, 255, 0.25 )',
                                        boxShadow: '0 8px 32px 0 rgba( 31, 38, 135, 0.37 )',
                                        backdropFilter: 'blur( 4px )',
                                        webkitbackdropFilter: 'blur( 4px )',
                                        borderRadius: '10px',
                                        border: '1px solid #fff'}}>
                            <Card.Body>
                            <Card.Img variant="top" src="https://res.cloudinary.com/ddnflcfy1/image/upload/v1618551342/Wizard-3D-icons/metal_ring-removebg-preview_jydily_oi3xp8.png" style={{width: '50%'}} />
                            <Button href="https://res.cloudinary.com/ddnflcfy1/image/upload/v1618551342/Wizard-3D-icons/metal_ring-removebg-preview_jydily_oi3xp8.png" download style={{marginTop: 30, width: '100%'}}>Download <i class="fa fa-download"></i></Button>
                            </Card.Body>
                          </Card>
                            </CardDeck>

                            <h5 style={{paddingBottom: 25, color: '#333', textDecoration: 'none'}}>
                            Download & use it anywhere</h5>

      </Container>
    </div>
  );
}

export default App;
